const normalizeDate = (v) => {
  if (!v) return null
  if (typeof v === 'number') return new Date(v)
  if (v instanceof Date) return v
  // 兼容 "2026-09-28 14:32:10" 空格分隔 → 浏览器统一用 T
  if (typeof v === 'string') {
    const s = v.replace(' ', 'T')
    const d = new Date(s)
    if (!isNaN(d.getTime())) return d
  }
  return null
}

export const formatDate = (dateStr) => {
  const d = normalizeDate(dateStr)
  if (!d) return dateStr || ''
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export const formatDateTime = (dateStr) => {
  const d = normalizeDate(dateStr)
  if (!d) return dateStr || ''
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  const hours = String(d.getHours()).padStart(2, '0')
  const minutes = String(d.getMinutes()).padStart(2, '0')
  const seconds = String(d.getSeconds()).padStart(2, '0')
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}
